import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { clearContextMessagesInActiveWorkArea } from '../../messages';
import { processDataToDispatchErrorAction, dispatchCorrectActionIfChildOrRemote } from '../../store/state/epics/util';
import { isErrorActionType, promiseHandler } from '../common-helper';
import { postProcessOpenActionRequest } from '../open-action-helper';
import type { Action } from '../../store/state/state-manager';

import { OPEN_PROCESS_ACTION } from './action-creator';
import { processOpenProcessActionRequest } from './async-request';

const openProccessAction = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: any[] = [];
  return action$.pipe(
    ofType(OPEN_PROCESS_ACTION),
    map((action: Action) => {
      ({ actionMgrID } = action.payload);
      return action.payload;
    }),
    mergeMap((actionInPayload) => {
      clearContextMessagesInActiveWorkArea(actionInPayload.context);
      return processOpenProcessActionRequest(actionInPayload, { actionMgrID, isProcessAction: true });
    }),
    mergeMap(async (chainedData) => {
      if (chainedData && isErrorActionType(chainedData.type)) {
        const errorAction = processDataToDispatchErrorAction(chainedData);
        actionsOut.push(errorAction);
        return actionsOut;
      }

      const { actionInPayload, headers, response } = chainedData;

      await postProcessOpenActionRequest(response, actionsOut, { headers, actionInPayload });

      return actionsOut;
    }),
    map(() => {
      dispatchCorrectActionIfChildOrRemote(actionsOut);
      promiseHandler(actionsOut, actionMgrID);
      actionsOut = [];
      return actionsOut;
    })
  );
};

export default openProccessAction;
